












































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic,
  Configuration,
} from "@/configuration";
import API from "@/api";
import DniEmpresa from "@/components/DniFieldLandingSantanderBusiness.vue";
import AlertsBusiness from "@/components/AlertsBusiness.vue";
import { EventBus } from "@/main";
@Component({
  metaInfo() {
    return {
      title: "RedCapital | Operación empresa",
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang,
      },
    };
  },
  data() {
    return {
      RedCapital, // por definir
      SelectedCountry, // por definir,
      showPassword: false,
      alerts: false,
      canPress: true,
      stateToken: null,
      error: null,
      terms: false,
      showError: false,
      valid: false,
      cargando:false,
      validacionData: {
        rut_empresa: null,
        usuario_id: null,
      },
      form: {
        email:'',
        businessDni: null,
        password: null,
        location: "landing_empresas",
      },
      rules: {
        password: [(v: any) => !!v || "La contraseña es requerida"],
        required: [(v: any) => !!v || "Acepte los términos y condiciones"],
        email:[
          (v: any) => !!v || 'E-mail es requerido',
          (v: any) => /^.+@.+\..+/gi.test(v) || 'El e-mail tiene que ser valido',
          (v: any) => !!v || "Ingrese un valor"
        ],
      },
    };
  },
  computed: {
    logo() {
      return "/images/logo-redcapital-head.png";
    },
    home() {
      return "/images/landingempresa/padlock-home.png";
    },
    hand() {
      return "/images/landingempresa/hands.png";
    },
    check() {
      return "/images/landingempresa/Check.png";
    },
  },
  beforeMount() {},
  methods: {
    async onSubmit() {
     this.$data.cargando = true;
      if (this.$data.terms == true) {
        // @ts-ignore
        if (this.$refs.form.validate()) {
          API.empresaClaveSii(this.$data.form)
            .then((res: any) => {
              this.$data.cargando = false;
              this.$data.canPress = true;
               EventBus.$emit("alertsbusiness", true);
            })
            .catch((e) => {
              this.$data.canPress = true;
              this.$data.cargando = false;
              // this.$data.alerts = true;
              EventBus.$emit("alertsbusinessError", true);
              // setTimeout(() => {
              //   EventBus.$emit("alertsbusinessError", false);
              //   this.$data.alerts = false;
              // }, 3000);
            });
        }
      }
    },
    termError() {
      this.$data.showError = true;
      setTimeout(() => {
        this.$data.showError = false;
      }, 2500);
    },
    showModalExito() {
      this.$data.modal.showModal = true;
      this.$data.modal.mensaje = "Tu contraseña se ha guardado exitosamente";
      this.$data.modal.img = "/images/claveSii/ico_checkPass.png";
      setTimeout(() => {
        this.$data.modal.showModal = false;
        this.$data.modal.mensaje = null;
        this.$data.modal.img = null;
        this.$router.push({
          path: "/",
        });
      }, 3000);
    },
  },
  components: {
    DniEmpresa,
    AlertsBusiness,
  },
})
export default class ClaveSiiProject extends Vue {
  @Prop() token!: number;
}
